export default function Pricetags() {
  return (
    <div
      className="ion-icon-pricetags"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
<g>
	<path d="M472,239.2L472,239.2C472,239.2,471.9,239.2,472,239.2L282.1,48.1c0,0,0,0,0,0l-1.4-1.4c0,0-0.5,0-0.5,0
		c-7.5-7.2-16.1-10.9-27.1-11.1v0l-89.9-3.3l-3.9-0.1c-10.1,0.1-20,4.1-27.7,11.8l-27.1,27.2c7.4-6.6,16.6-10,26-10.1l3.8,0.1
		l89.8,3.3v0c11,0.2,19.7,3.9,27.2,11.1c0,0,0.4,0,0.5,0l1.4,1.4c0,0,0,0,0,0L443,268.1c0,0,0,0,0,0v0c10,10.8,10.7,28.2,0,38.9
		l29-28.9C482.6,267.4,482,250,472,239.2z"/>
	<path d="M428,282.5c0,0,0.3,0,0.3,0L238.6,91.4c0,0,0,0,0,0l-1.3-1.4c0,0-0.3,0-0.3,0c-7.5-7.2-15.9-10.9-26.9-11.1v0l-90.1-3.3
		l-4-0.1c-9.2,0.1-18.2,3.4-25.6,9.8c-0.3,0.3-0.7,0.6-1,0.9c-0.4,0.4-0.8,0.8-1.2,1.2l-44.3,44.5c-8.1,8.1-11.9,18.9-11.9,29.5
		c0,0,0,0,0,0.1l0.1,3.8l5.9,87.9c0,0.1,0,0.1,0,0.2v1.7c0,0,0,0,0,0c1,7.9,4.2,15.6,9.6,22l5.1,4.9L239,470.4l2.8,2.8
		c10.7,9.4,27.1,9,37.3-1.3l13.1-13.2c0.5-0.4,0.9-0.8,1.4-1.3l26.9-27c-0.2,0.1-0.3,0.2-0.5,0.4l108.3-109.3
		C438.9,310.8,439,293.3,428,282.5L428,282.5z M110.6,139.5c6.6-4,14.3-6.3,22.6-6.3c23.9,0,43.4,19.4,43.4,43.4
		c0,8.3-2.3,16-6.3,22.6c-7.6,12.5-21.3,20.8-37,20.8c-23.9,0-43.4-19.4-43.4-43.4C89.8,160.8,98.1,147.1,110.6,139.5z"/>
</g>
</svg>
`,
      }}
    />
  )
}
